// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountGroup } from './account-group';
import { CreditorClaim } from './creditor-claim';
import { CreditorClass } from './creditor-class';
import { Dividend } from './dividend';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditorClaimType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  creditorClaimTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  creditorClassId!: number;
  description!: string;
  description3!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountGroups!: AccountGroup[];
  creditorClaims!: CreditorClaim[];
  creditorClass!: CreditorClass;
  dividends!: Dividend[];
}

